import React from 'react';
const tomos = [{
  emoji: '📘',
  title: 'Tomo 1 — El Protocolo de Mentalidad Operativa',
  desc: 'Sistema Operativo del Operador, bloques de 90 minutos, ingeniería de metas e implementación imperfecta. La base mental que diferencia al que construye del que consume.'
}, {
  emoji: '📗',
  title: 'Tomo 2 — Ingeniería de Mercado y Nicho',
  desc: 'El Triángulo de Oro, análisis de competidores, auditoría de demanda real y avatar comprador de 3 dimensiones. Cómo elegir el nicho correcto con datos y no con intuición.'
}, {
  emoji: '📙',
  title: 'Tomo 3 — Arquitectura de la Oferta Irresistible',
  desc: 'Fórmula del valor percibido, anclaje de precio, ingeniería de bonos y garantía que elimina el riesgo. Cómo hacer que tu producto parezca una ganga aunque no lo sea.'
}, {
  emoji: '📕',
  title: 'Tomo 4 — El Motor de Ventas',
  desc: 'VSL de 12 pasos, landing page de alta conversión, secuencias de email automáticas y el embudo completo. El sistema que vende mientras dormís.'
}, {
  emoji: '📓',
  title: 'Tomo 5 — Tráfico Maestro: Meta Ads',
  desc: 'Estructura de campañas, audiencias, creativos de alta retención, optimización y escalado. Cómo dominar Meta Ads sin quemar el presupuesto aprendiendo.'
}, {
  emoji: '📔',
  title: 'Tomo 6 — Escalabilidad e Inteligencia Operativa',
  desc: 'IA aplicada al negocio, automatización, ecosistema de productos y transición de operador a CEO. Cómo crecer sin trabajar más horas.'
}];
const checklist = ['Marco de implementación inmediata', 'Checklists y plantillas listas para usar', 'Casos prácticos del mercado argentino', 'Hojas de trabajo completables', 'Scripts y guiones adaptables', 'Ejemplos reales de emprendedores argentinos', '100% adaptado al contexto económico Argentina 2025'];
const bonos = [{
  num: '01',
  title: 'El Libro de los Scripts',
  desc: 'Más de 200 scripts listos para adaptar: hooks de anuncios, textos de landing page, emails de nurturing, mensajes de WhatsApp y cierres de venta. El copy profesional sin contratar a nadie.',
  value: '$15.000'
}, {
  num: '02',
  title: 'El Arsenal Digital',
  desc: 'Las herramientas low-cost y no-code para construir el negocio sin ser técnico. Stack completo con costos, comparativas y guías de configuración paso a paso.',
  value: '$12.000'
}, {
  num: '03',
  title: 'Protocolo WhatsApp de Cierre',
  desc: 'El sistema de 5 etapas para convertir conversaciones en ventas sin presionar ni perseguir. Scripts completos por tipo de lead, manejo de objeciones y sistema de seguimiento.',
  value: '$12.000'
}, {
  num: '04',
  title: 'El Calendario de los 90 Días',
  desc: 'Tu mapa de implementación día a día para pasar de la idea al negocio operando. 90 días detallados con acciones, entregables y hitos de control.',
  value: '$15.000'
}, {
  num: '05',
  title: 'Blindaje Financiero y Monotributo',
  desc: 'Cómo ordenar tus cobros, costos e impuestos sin ahogarte en el caos argentino. El Sistema de las 4 Cuentas, el flujo de caja mensual y la guía del Monotributo para emprendedores digitales.',
  value: '$12.000'
}, {
  num: '06',
  title: 'Master de Prompts para Negocios con IA',
  desc: 'La biblioteca completa de más de 100 prompts para crear más rápido, vender mejor y operar con menos esfuerzo. Prompts maestros para anuncios, emails, copy, análisis y automatización.',
  value: '$15.000'
}];
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-[#0A0A0A] border-y border-neutral-800" data-id="element-146">
      <div className="max-w-6xl mx-auto px-4" data-id="element-147">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-148">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#D4AF37]/10 text-[#D4AF37] font-bold text-sm mb-6 border border-[#D4AF37]/20" data-id="element-149">
            🏆 KIT MÁQUINA DE VENTAS™
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-150">
            6 Tomos + 6 Guías de Acción
          </h2>
          <p className="text-lg md:text-xl text-gray-400" data-id="element-151">
            El Protocolo N°1 para Emprendedores Digitales en Argentina
          </p>
          <p className="text-base text-gray-500 mt-2" data-id="element-152">
            Más de 480 páginas — todo listo para implementar.
          </p>
        </div>

        {/* Tomos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-153">
          {tomos.map((t, i) => <div key={i} className="bg-neutral-950 border border-neutral-800 rounded-2xl p-6 md:p-8 hover:border-[#D4AF37]/50 transition-all group" data-id="element-154">
              <div className="text-4xl md:text-5xl mb-5 group-hover:scale-110 transition-transform origin-left" data-id="element-155">
                {t.emoji}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-156">
                {t.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm md:text-base" data-id="element-157">
                {t.desc}
              </p>
            </div>)}
        </div>

        {/* Checklist */}
        <div className="max-w-3xl mx-auto bg-neutral-900/40 border border-neutral-800 rounded-2xl md:rounded-3xl p-6 md:p-10 mb-20 md:mb-28" data-id="element-158">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6 md:mb-8 text-center" data-id="element-159">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-160">
            {checklist.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-161">
                <span className="text-[#D4AF37] mt-0.5 shrink-0" data-id="element-162">✅</span>
                <span className="text-gray-300 font-medium text-sm md:text-base" data-id="element-163">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Bonuses Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-164">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-165">
            🎁 6 GUÍAS DE ACCIÓN INMEDIATA
          </h2>
          <p className="text-lg text-[#D4AF37] font-semibold uppercase tracking-wider" data-id="element-166">
            Siempre incluidas
          </p>
        </div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-167">
          {bonos.map((b, i) => <div key={i} className="bg-gradient-to-b from-neutral-900 to-neutral-950 border border-neutral-800 rounded-2xl p-6 md:p-8 relative overflow-hidden flex flex-col" data-id="element-168">
              <div className="absolute top-0 right-0 w-28 h-28 bg-[#D4AF37]/5 rounded-bl-full -mr-8 -mt-8" data-id="element-169" />
              <div className="text-[#D4AF37] font-mono font-bold text-lg mb-3" data-id="element-170">
                GUÍA {b.num}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-171">
                {b.title}
              </h3>
              <p className="text-gray-400 text-sm md:text-base mb-6 flex-1" data-id="element-172">
                {b.desc}
              </p>
              <div className="pt-5 border-t border-neutral-800 flex items-center justify-between" data-id="element-173">
                <span className="text-gray-500 line-through font-mono text-sm" data-id="element-174">
                  {b.value}
                </span>
                <span className="bg-gradient-to-b from-[#E5C158] to-[#D4AF37] text-black font-bold px-3 py-1 rounded-md text-xs uppercase tracking-wide" data-id="element-175">
                  Gratis
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value */}
        <div className="max-w-xl mx-auto text-center bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-2xl p-6 md:p-8" data-id="element-176">
          <div className="text-gray-400 font-medium mb-2 uppercase tracking-wider text-sm" data-id="element-177">
            Valor total guías
          </div>
          <div className="text-2xl md:text-3xl font-bold" data-id="element-178">
            <span className="line-through text-gray-500 mr-3" data-id="element-179">$81.000</span>
            <span className="text-[#D4AF37]" data-id="element-180">→ GRATIS con tu Kit</span>
          </div>
        </div>
      </div>
    </section>;
}